import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Copyright 2022 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import React from 'react';
import ReactDOM from 'react-dom';
import { ThemeProvider } from "../../theme";
const PortalContext = React.createContext({ scopeRef: undefined });
export const usePortal = () => {
    return React.useContext(PortalContext);
};
/**
 * Disclaimer: Works only for components that don't show the portal immediately
 * That gives Portal time to receive scope on first render
 */
export const PortalProvider = (props) => {
    var _a;
    const { children, scopeRef } = props;
    const portal = usePortal();
    const nextScopeRef = scopeRef || portal.scopeRef;
    return ReactDOM.createPortal(_jsx(PortalContext.Provider, { value: { scopeRef: nextScopeRef }, children: _jsx(ThemeProvider, { colorMode: "light", children: children }) }), ((_a = portal.scopeRef) === null || _a === void 0 ? void 0 : _a.current) || document.body);
};
